export default {
  deviceList: [],
  currentOrg: {},
};
